__turbopack_export_value__({
  "body-logo-18": "Structure-module-scss-module__OZrdzq__body-logo-18",
  "body-text-12": "Structure-module-scss-module__OZrdzq__body-text-12",
  "body-text-14": "Structure-module-scss-module__OZrdzq__body-text-14",
  "body-text-16": "Structure-module-scss-module__OZrdzq__body-text-16",
  "body-text-18": "Structure-module-scss-module__OZrdzq__body-text-18",
  "body-text-20": "Structure-module-scss-module__OZrdzq__body-text-20",
  "body-text-24": "Structure-module-scss-module__OZrdzq__body-text-24",
  "body-text-24-2": "Structure-module-scss-module__OZrdzq__body-text-24-2",
  "body-text-heading-2": "Structure-module-scss-module__OZrdzq__body-text-heading-2",
  "body-text-heading-3": "Structure-module-scss-module__OZrdzq__body-text-heading-3",
  "body-text-medium-14": "Structure-module-scss-module__OZrdzq__body-text-medium-14",
  "body-text-medium-16": "Structure-module-scss-module__OZrdzq__body-text-medium-16",
  "body-text-medium-18": "Structure-module-scss-module__OZrdzq__body-text-medium-18",
  "body-text-medium2-18": "Structure-module-scss-module__OZrdzq__body-text-medium2-18",
  "body-text2-14": "Structure-module-scss-module__OZrdzq__body-text2-14",
  "body-text2-16": "Structure-module-scss-module__OZrdzq__body-text2-16",
  "button-primary-text": "Structure-module-scss-module__OZrdzq__button-primary-text",
  "button-text": "Structure-module-scss-module__OZrdzq__button-text",
  "button2-text": "Structure-module-scss-module__OZrdzq__button2-text",
  "card-shadow": "Structure-module-scss-module__OZrdzq__card-shadow",
  "effect-menu": "Structure-module-scss-module__OZrdzq__effect-menu",
  "header-1": "Structure-module-scss-module__OZrdzq__header-1",
  "main-container": "Structure-module-scss-module__OZrdzq__main-container",
  "main-footer-container": "Structure-module-scss-module__OZrdzq__main-footer-container",
  "main-header-container": "Structure-module-scss-module__OZrdzq__main-header-container",
  "structure": "Structure-module-scss-module__OZrdzq__structure",
  "structure__button": "Structure-module-scss-module__OZrdzq__structure__button",
  "structure__content": "Structure-module-scss-module__OZrdzq__structure__content",
  "structure__head": "Structure-module-scss-module__OZrdzq__structure__head",
  "structure__hint": "Structure-module-scss-module__OZrdzq__structure__hint",
  "structure__hintWrapper": "Structure-module-scss-module__OZrdzq__structure__hintWrapper",
  "structure__item": "Structure-module-scss-module__OZrdzq__structure__item",
  "structure__item_active": "Structure-module-scss-module__OZrdzq__structure__item_active",
  "structure__list": "Structure-module-scss-module__OZrdzq__structure__list",
  "structure__track": "Structure-module-scss-module__OZrdzq__structure__track",
  "txt-12-bold": "Structure-module-scss-module__OZrdzq__txt-12-bold",
  "txt-14-bold": "Structure-module-scss-module__OZrdzq__txt-14-bold",
  "txt-14-bold-caps": "Structure-module-scss-module__OZrdzq__txt-14-bold-caps",
  "txt-14-med": "Structure-module-scss-module__OZrdzq__txt-14-med",
  "txt-16-bold": "Structure-module-scss-module__OZrdzq__txt-16-bold",
  "txt-16-med": "Structure-module-scss-module__OZrdzq__txt-16-med",
  "txt-18-bold": "Structure-module-scss-module__OZrdzq__txt-18-bold",
  "txt-18-medium": "Structure-module-scss-module__OZrdzq__txt-18-medium",
  "txt-18-medium-24": "Structure-module-scss-module__OZrdzq__txt-18-medium-24",
  "txt-24-semi": "Structure-module-scss-module__OZrdzq__txt-24-semi",
});
